export const getPercentComplete = (earnHours: number, totalHours: number): number => {
  if (totalHours <= 0) return 0;
  const percentComplete = (earnHours / totalHours) * 100;
  //Based on current logic - 99.9 percent is not 100% complete of workpackage, but 0.5 should be rounded off to 1% complete
  if (percentComplete > 99 && percentComplete < 100) return 99;
  return Math.round(percentComplete);
};
